import { BaseAPI } from '../base.api';
import { VUE_APP_FINANCEIRO_API_URL, VUE_APP_PDF_URL } from '@/commons/config'
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface';

export class CertidaoNegativaAPI extends BaseAPI<any> {
  protected apiPdfUrl: string

  constructor() {
    super()
    this.apiUrl = `${VUE_APP_FINANCEIRO_API_URL}/api`
    this.apiPdfUrl = `${VUE_APP_PDF_URL}`
  }

  public findByTokenAndCpfCnpj(token: string, cpfCnpj: string): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}/certidaonegativapositiva/?token=${token}&cpfcnpj=${cpfCnpj}`)
  }

  public generatePdf(recaptcha: string, cpfCnpj: string): AxiosObservable<any> {
    return this.axios.post(`${this.apiUrl}/pdf/certidao/`, { cpfcnpj: cpfCnpj, recaptcha: recaptcha }, { responseType: "blob" })
  }
}
